// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Save: React.FC<{ width?: number; height?: number }> = ({ width = 11, height = 11 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 11">
            <path
                fill="currentColor"
                d="M1.571 0C.712 0 0 .712 0 1.571V9.43C0 10.288.712 11 1.571 11H9.43C10.288 11 11 10.288 11 9.429V3.462c0-.417-.172-.81-.467-1.105L8.643.467A1.56 1.56 0 0 0 7.538 0zm.786 2.357c0-.442.344-.786.786-.786H7.07c.442 0 .786.344.786.786V3.93a.776.776 0 0 1-.786.785H3.143a.776.776 0 0 1-.786-.785zM5.5 6.286c.86 0 1.571.712 1.571 1.571 0 .86-.712 1.572-1.571 1.572-.86 0-1.571-.712-1.571-1.572S4.64 6.286 5.5 6.286"
            />
        </svg>
    );
};

export default React.memo(Save);
